/* Bahar Art Creations – theme.js */

/*
 * Gallery, variant selection, product accordion, and sticky ATC are all
 * handled by main-product.liquid's own {% javascript %} block.
 * theme.js is responsible only for: AJAX cart add, cart drawer, FAQ accordion,
 * and cart count sync, functionality shared across all page types.
 */

/* ---- Add to cart (AJAX) -------------------------------------------- */
function initAddToCart() {
  const form = document.querySelector('.shopify-product-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('[data-atc-btn]');
    if (!btn || btn.disabled) return;

    const originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    const data = new FormData(form);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        body: data,
      });
      if (!res.ok) throw new Error('Cart add failed');
      const json = await res.json();
      updateCartCount();
      btn.textContent = '✓ Added';
      setTimeout(() => {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1800);
      if (window.__openCartDrawer) window.__openCartDrawer();
    } catch {
      btn.textContent = originalText;
      btn.disabled = false;
    }
  });
}

async function updateCartCount() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach((el) => { el.textContent = cart.item_count; });
  } catch {}
}

/* ---- Cart drawer --------------------------------------------------- */
function initCartDrawer() {
  const drawer = document.getElementById('cart-drawer');
  const overlay = document.getElementById('cart-drawer-overlay');
  const closeBtn = document.getElementById('cart-drawer-close');
  const cartIcons = document.querySelectorAll('[data-open-cart]');
  if (!drawer) return;

  function openCartDrawer() {
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-visible');
    renderCartDrawer();
  }
  function closeCartDrawer() {
    drawer.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-visible');
  }

  cartIcons.forEach((btn) => btn.addEventListener('click', (e) => {
    e.preventDefault();
    openCartDrawer();
  }));
  if (closeBtn) closeBtn.addEventListener('click', closeCartDrawer);
  if (overlay) overlay.addEventListener('click', closeCartDrawer);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.getAttribute('aria-hidden') === 'false') closeCartDrawer();
  });

  window.__openCartDrawer = openCartDrawer;
}

async function renderCartDrawer() {
  const body = document.getElementById('cart-drawer-body');
  const footer = document.getElementById('cart-drawer-footer');
  const subtotalEl = document.getElementById('cart-drawer-subtotal');
  if (!body) return;

  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();

    const countEls = document.querySelectorAll('[data-cart-count]');
    countEls.forEach((el) => { el.textContent = cart.item_count; });

    if (cart.item_count === 0) {
      body.innerHTML = '<div class="cart-drawer__empty"><p>Your cart is empty</p><a href="/collections/all" class="btn">Continue shopping</a></div>';
      if (footer) footer.hidden = true;
      return;
    }

    const esc = (s) => String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const itemsHTML = cart.items.map((item) => {
      const price = (item.line_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
      const imgTag = item.image ? `<img src="${esc(item.image)}" alt="${esc(item.product_title)}" class="cart-drawer__item-img" width="72" height="72" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__item-variant">${esc(item.variant_title)}</p>` : '';
      return `<div class="cart-drawer__item">
        ${imgTag}
        <div>
          <p class="cart-drawer__item-title">${esc(item.product_title)}</p>
          ${variant}
          <p class="cart-drawer__item-qty">Qty: ${item.quantity}</p>
          <button type="button" class="cart-drawer__item-remove" data-key="${esc(item.key)}">Remove</button>
        </div>
        <p class="cart-drawer__item-price">${price}</p>
      </div>`;
    }).join('');

    body.innerHTML = itemsHTML;

    body.querySelectorAll('.cart-drawer__item-remove').forEach((btn) => {
      btn.addEventListener('click', async () => {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: btn.dataset.key, quantity: 0 }),
        });
        renderCartDrawer();
      });
    });

    if (footer) footer.hidden = false;
    if (subtotalEl) {
      subtotalEl.textContent = (cart.total_price / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
    }

    const shippingProgress = document.getElementById('cart-shipping-progress');
    const shippingMsg = document.getElementById('cart-shipping-msg');
    const shippingFill = document.getElementById('cart-shipping-fill');
    if (shippingProgress && window.__showFreeShippingBar) {
      const threshold = window.__freeShippingThreshold || 15000;
      shippingProgress.hidden = false;
      const pct = Math.min(100, Math.round((cart.total_price / threshold) * 100));
      if (shippingFill) shippingFill.style.width = pct + '%';
      if (shippingMsg) {
        if (cart.total_price >= threshold) {
          shippingMsg.innerHTML = '<strong>You\'ve unlocked free shipping! 🎉</strong>';
        } else {
          const remaining = ((threshold - cart.total_price) / 100).toLocaleString('en-US', { style: 'currency', currency: cart.currency });
          shippingMsg.innerHTML = 'Add <strong>' + remaining + '</strong> more for free shipping';
        }
      }
    } else if (shippingProgress) {
      shippingProgress.hidden = true;
    }
  } catch {
    body.innerHTML = '<p class="cart-drawer__loading">Could not load cart.</p>';
  }
}

/* ---- FAQ accordion ------------------------------------------------- */
function initFAQ() {
  document.querySelectorAll('.faq-item__question').forEach((btn) => {
    btn.addEventListener('click', () => {
      const expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      const answer = btn.nextElementSibling;
      answer.style.maxHeight = expanded ? '0' : answer.scrollHeight + 'px';
    });
  });
}

/* ---- Init on DOM ready --------------------------------------------- */
document.addEventListener('DOMContentLoaded', () => {
  initAddToCart();
  initFAQ();
  initCartDrawer();
});
